import { Link, useLocation } from "react-router-dom";

const CustomLink = ({ to, ...props }) => {
  const location = useLocation();

  const isFootball = location.pathname.startsWith("/football");
  const basePath = isFootball ? "/football" : "";

  const finalPath = `${basePath}/${to}`.replace(/\/+/g, "/");

  return <Link to={finalPath} {...props} />;
};

export default CustomLink;
